import React from "react";
import { Tooltip, Typography } from "@mui/material";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { useArchiveBoardState } from "./hooks/useArchiveBoardState";

export const ArchiveBoard = React.memo(function ArchiveBoard({
  boardId,
  isActive,
}) {
  const {
    archiveBoardDialog,
    dialogButtonText,
    dialogMessage,
    dialogTitle,
    isBoardCurrentlyActive,
    submitArchiveStatusChange,
    tooltipTitle,
  } = useArchiveBoardState({
    boardId,
    isActive,
  });

  return (
    <div className="w-100 d-flex justify-content-center">
      <Tooltip title={tooltipTitle}>
        <label className="switch">
          <input
            type="checkbox"
            value={isBoardCurrentlyActive}
            checked={isBoardCurrentlyActive}
            onChange={archiveBoardDialog.openDialog}
          />
          <div className="slider"></div>
        </label>
      </Tooltip>
      {archiveBoardDialog.isDialogOpen && (
        <FormDialog
          open={archiveBoardDialog.isDialogOpen}
          handleClose={archiveBoardDialog.closeDialog}
          handleSubmit={submitArchiveStatusChange}
          loading={archiveBoardDialog.isSubmitting}
          buttonTxt={dialogButtonText}
          title={dialogTitle}
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2 ">
            {dialogMessage}
          </Typography>
        </FormDialog>
      )}
    </div>
  );
});
